import { URL_API, REQUEST_HEADER_AUTH_KEY } from 'constants/api.constant'
import ApiService from './ApiService'

export async function apiSignIn(data) {
    return ApiService.fetchData({
        url: `${URL_API}/login`,
        method: 'post',
        data,
    })
}

// ── Registro self-serve (landing → asistente) ────────────────────────────────
// El alta replica la cadena ya probada en la app móvil: crear empresa (público) →
// crear usuario admin gratis (público) → login. Ambos POST son públicos, así que no
// necesitan token. Los pasos de suscripción sí requieren el JWT recién obtenido y lo
// reciben explícito en el header: `ApiService` lee el token de localStorage (vía
// redux-persist, que escribe con retardo), y justo tras el login aún no está allí.

/** Paso 1 del alta. Público (sin token). Devuelve la empresa creada con su `id`. */
export async function apiCrearEmpresa(data) {
    return ApiService.fetchData({
        url: `${URL_API}/empresas`,
        method: 'post',
        data,
    })
}

/** Paso 2 del alta. Público. Requiere `empresa` (id del paso 1). Devuelve el usuario creado. */
export async function apiRegistroGratis(data) {
    return ApiService.fetchData({
        url: `${URL_API}/usuarios/crear/gratis`,
        method: 'post',
        data,
    })
}

/** Planes activos para resolver el `id` del plan elegido por su `codigo`. Requiere JWT. */
export async function apiPlanesActivos(token) {
    return ApiService.fetchData({
        url: `${URL_API}/planes/activos`,
        method: 'get',
        headers: { [REQUEST_HEADER_AUTH_KEY]: token },
    })
}

/** Inicia la facturación de la propia empresa (admin) y devuelve `{ checkoutUrl }`. Requiere JWT. */
export async function apiIniciarSuscripcion(data, token) {
    return ApiService.fetchData({
        url: `${URL_API}/suscripciones/iniciar-propia`,
        method: 'post',
        data,
        headers: { [REQUEST_HEADER_AUTH_KEY]: token },
    })
}

export async function apiSignUp(data) {
    return ApiService.fetchData({
        url: '/sign-up',
        method: 'post',
        data,
    })
}

export async function apiSignOut(data) {
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data,
    })
}

export async function apiForgotPassword(data) {
    return ApiService.fetchData({
        url: '/forgot-password',
        method: 'post',
        data,
    })
}

export async function apiResetPassword(data) {
    return ApiService.fetchData({
        url: '/reset-password',
        method: 'post',
        data,
    })
}
